// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"180":"App","214":"views-error","475":"views"}[chunkId] || chunkId) + "." + {"180":"835cf652","214":"91b098e9","475":"b291fd4f","826":"a74c83a9","837":"649d1484","990":"fbc327c7","993":"91f56f45"}[chunkId] + ".chunk.js";
};